'use strict';

function _typeof(obj) { return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj; }

/* jshint node: true, esnext: true, loopfunc: true, undef: true, unused: true */
/* global window, global, self */

var undefStr = 'undefined';

module.exports = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== undefStr ? window : (typeof global === 'undefined' ? 'undefined' : _typeof(global)) !== undefStr ? global : (typeof self === 'undefined' ? 'undefined' : _typeof(self)) !== undefStr ? self : {};


/*****************
 ** WEBPACK FOOTER
 ** ./~/zero-lang/global.js
 ** module id = 1
 ** module chunks = 0
 **/